<template>
    <div class="approach-config-main">
        <div class="approach-config-left" v-show="visible.tree">
            <el-container>
                <el-main ref="elMain" style="height: calc(100vh - 10rem)">
                    <el-tree
                            class="filter-tree"
                            :data="tree"
                            :props="defaultProps"
                            :filter-node-method="filterNode"
                            default-expand-all
                            v-loading="loading"
                            @node-click="click"
                            highlight-current
                            :expand-on-click-node="false"
                            ref="tree"
                            :indent="fontSize"

                    >
                    </el-tree>
                    <center>
                        <el-button v-if="tree.length === 0 && !loading" @click="selectApproach">刷新</el-button>
                    </center>
                </el-main>
            </el-container>
        </div>

        <div class="div-hr-h"></div>
        <div class="approach-config-content">

            <!--口径设置中显示-->
            <div v-if="visible.approach && this.visibleType === 1">
                <el-button slot="reference" type="primary" size="small"
                           @click="deleteApproach()">删除口径
                </el-button>
            </div>
            <div v-if="visible.approach && this.visibleType === 0">
                <el-button slot="reference" type="primary" size="small"
                           @click="submitForm('energyUnitForm')">添加口径
                </el-button>
            </div>

            <br/>
            <div style="display: flex;">
                <el-form :model="form" size="small" :rules="myRules" ref="energyUnitForm">

                    <el-form-item label="口径名称" :label-width="formLabelWidth"
                                  prop="name">
                        <el-input v-model="form.name" auto-complete="on"
                                  @blur="form.name = form.name.replace(/\s/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="启用状态" :label-width="formLabelWidth" prop="enabled">
                        <el-select v-model="form.enabled" placeholder="启用状态">
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="停用" :value="0"></el-option>
                        </el-select>
                    </el-form-item>

                    <!--在口径设置中出现-->
                    <el-form-item label="口径类型" :label-width="formLabelWidth"
                                  prop="type">
                        <el-select v-model="form.type" placeholder="请选择">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="排列顺序" :label-width="formLabelWidth" prop="order" selectApproachById>
                        <el-input-number v-model="form.order" :min="0" :max="1000"></el-input-number>
                    </el-form-item>
                    <!--均出现-->

                    <el-form-item label="备注" :label-width="formLabelWidth" prop="note">
                        <el-input
                                type="textarea"
                                placeholder="请输入内容"
                                v-model="form.note">
                        </el-input>
                    </el-form-item>

                    <center>
                        <el-form-item v-if="visibleType === 1">
                            <el-button type="primary" @click="submitForm('energyUnitForm')" v-loading="loading">
                                保 存
                            </el-button>
                        </el-form-item>

                    </center>
                </el-form>


            </div>

        </div>

    </div>
</template>

<script>
  import {insertApproach, list, selectApproachById, deleteApproach} from '@/api/Approach'
  import Flex from "../../../../components/Flex"
  import {mapGetters} from 'vuex'
  import {checkNum} from '@/utils/validate'

  export default {
    name: '',
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val)
      }
    },
    computed: {
      ...mapGetters([
        'fontSize'
      ])
    },
    mounted() {
      this.tree = []
      this.visible.tree = true
      this.typeName = '添加口径'
      this.selectApproach()
    },
    methods: {
      resetForm(formName) { /* 移除表单检验结果*/
        if (this.$refs[formName] !== undefined) {
          this.$refs[formName].resetFields()
        }
      },
      click(data, node) { /* 树点击事件 */
        this.current = data
        this.resetForm('energyUnitForm')
        /* grade : 0 添加口径 1修改口径*/
        if (data.grade === 0) { /* 添加口径*/
          this.visible.approach = true
          this.typeName = '添加口径'
          this.visibleType = 0
          this.cleanData(this.form)
        } else if (data.grade === 1) { /* 修改口径信息*/
          this.cleanData(this.form)
          this.visible.approach = true
          this.title = '添加能耗单元'
          this.typeName = '修改口径'
          this.visibleType = 1
          this.selectApproachById(data.id)

        }
      },
      selectApproachById(approachId) {
        selectApproachById(approachId).then(response => {
          if (response.code === 200) {
            const data = response.infoJson
            this.form.id = data.id
            this.form.name = data.name
            this.form.type = data.type
            this.form.enabled = data.enabled
            this.form.note = data.note
            this.form.order = data.order
          } else {
            this.$message({
              type: 'error',
              message: '查询口径信息失败!',
              duration: 5 * 1000
            })
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            type: 'error',
            message: '查询口径信息失败!',
            duration: 5 * 1000
          })
        })
      },
      selectApproach() {
        this.tree = []
        this.resetForm('energyUnitForm')
        this.cleanData(this.form)
        this.loading = true
        const customerId = this.$store.getters.customerId
        this.bildTree(customerId)
        this.visibleType = 0
      },
      deleteApproach() {
        if (this.current !== null && this.current !== undefined && this.current.id !== null && this.current.id !== undefined) {
          this.$confirm('此操作将永久删除该口径信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            deleteApproach(this.current.id).then(response => {
              if (response.code === 200) {
                if (response.infoJson === 200) {
                  this.$message({
                    type: 'error',
                    message: '该口径下存在能耗单元,无法删除该口径!',
                    duration: 5 * 1000
                  })
                }
                else if (response.infoJson === 1) {
                  this.$message({
                    type: 'success',
                    message: '删除成功!',
                    duration: 5 * 1000
                  })
                }
                else {
                  this.$message({
                    type: 'error',
                    message: '删除口径信息失败!',
                    duration: 5 * 1000
                  })
                }
              } else {
                this.$message({
                  type: 'error',
                  message: '删除口径信息失败!',
                  duration: 5 * 1000
                })
              }


              this.selectApproach()

            }).catch(error => {
              console.log(error)
              this.$message({
                type: 'error',
                message: '删除口径信息失败!',
                duration: 5 * 1000
              })
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })

        }
        else {
          this.$message({
            type: 'warring',
            message: '请选择要删除的口径!',
            duration: 5 * 1000
          })
        }
      },
      saveOrUpdateApproach() { /* 添加或更新口径信息*/
        this.loading = true
        const customerId = this.$store.getters.customerId
        const info = {
          customerId: customerId,
          id: this.form.id,
          name: this.form.name,
          type: this.form.type,
          enabled: this.form.enabled,
          order: this.form.order,
          note: this.form.note
        }
        insertApproach(info).then(response => {
          if (response.code === 200) {
            this.bildTree(customerId)
            if(this.form.id) this.selectApproachById(this.form.id)
            this.$message({
              type: 'success',
              message: '操作成功!',
              duration: 5 * 1000
            })
          }
          else {
            this.$message({
              type: 'error',
              message: '添加或更新口径信息失败!',
              duration: 5 * 1000
            })

            this.bildTree(customerId)
            if(this.form.id) this.selectApproachById(this.form.id)

          }
          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error)
          this.$message({
            type: 'error',
            message: '添加或更新口径信息失败!',
            duration: 5 * 1000
          })
        })
      },
      bildTree(customerId){
        this.tree = []
        list(customerId).then(response => {
          const data = response.infoJson
          this.tree.push({
            label: '口径设置',
            grade: 0,
            children: []
          })
          for (const i in data) {
            this.tree[0].children.push({
                id: data[i].id,
                label: data[i].name,
                name: data[i].name,
                order: data[i].order,
                grade: 1,
                note: data[i].note,
                enabled: data[i].enabled,
                type: data[i].type
              }
            )
          }

          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error)
        })
      },
      /* 表格间距 */
      cellPadding() {
        return 'padding:0'
      },
      handleSelectionChange(val) { /* 树变化 */
        this.multipleSelection = val
      },
      filterNode(value, data) {
        if (!value) return true
        return data.label.indexOf(value) !== -1
      },
      submitForm(formName) { /* 表单验证*/
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveOrUpdateApproach()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      cleanData(data) {
        for (const i in data) data[i] = ''
      }
    },
    data() {
      return {
        visible: {
          user: false, /* 能耗单元下业主用户显示相关*/
          customer: false, /* 业主用户显示相关*/
          approach: true, /* 口径显示相关*/
          energy: false, /* 能耗单元显示相关*/
          energyDialog: false, /* 能耗单元弹窗显示相关*/
          tree: false/* 树*/
        },
        myRules: {
          /* 正则*/
          approachName: [
            {required: true, message: '仪表名称不能为空', trigger: 'change'}
          ],
          aName: [
            {required: true, message: '请填写能耗单元名称', trigger: 'change'}
          ],
          enabled: [
            {required: true, message: '请选择是否启用', trigger: 'change'}
          ],
          order: [
            /*{required: true, message: '请填写排列顺序', trigger: 'change'},*/
            {validator: checkNum, trigger: 'change'}
          ],
          id: [
            {required: true, message: '请填写编号标号', trigger: 'change'}
          ],
          type: [
            {required: true, message: '请选择区域类型', trigger: 'change'}
          ],
          name: [
            {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'change'},
            {required: true, message: '请填写口径名称', trigger: 'change'}
          ],
          note: [{min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'change'},]
        },
        input: '',
        typeName: '', /* 弹窗标题*/
        filterText: '', /* 树搜索*/
        tree: [], /* 树*/
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        customer: [],
        loading: false, /* 加载*/
        multipleSelection: '',
        form: {id: '', name: '', type: '', enabled: '', note: '', order: ''},
        buttonLoading: false,
        formLabelWidth: '6rem',
        options: [
          {value: 'area', label: '区域'},
          {value: 'building', label: '楼宇'}
        ],
        value: '区域',
        visibleType: ''/* 0:添加口径 1:修改口径 2:添加能耗单元 3:添加子能耗单元*/,
        title: '',
        current: null
      }
    }
  }
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .approach-config-main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        box-sizing: border-box;
        button {
            /*font-size: 14px;*/
            font-weight: bold;
        }
        .approach-config-left {
            display: flex;
            width: 13vw;
            .el-tree {
                background-color: #fafafa;
                min-width: 100%;
                display:inline-block !important;
            }
            /*.el.tree.element.style {
                padding-left: 0rem;
            }*/
            /*
                    background-color: black;*/
        }
        .div-hr-h {
            height: 100%;
            width: 0.02rem;
            background-color: #dedede;
        }

        .approach-config-content {
            /* flex: 3;*/
            /*margin-right: 30px;*/
            /* background-color: orange;*/
            padding-top: 0.5rem;
            padding-left: 1rem; /*==等于左边栏宽度==*/
            /*  background-color: red;*/
            height: calc(100vh - 10rem);
            /*width: calc(80% - 2rem);*/
            width: calc(100% - 13vw - 1.02rem);

        }

    }

    /* #left.el-tree-node {
         min-width: 100%;
     }*/


</style>
